import React from 'react';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import { IItemWithoutShowSellerProps } from './IItemProps';
import SharedPurchaseItemCells from './SharedPurchaseItemCells';
import { ISellerExcessDepositViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface ISellerExcessDepositProps
  extends IItemWithoutShowSellerProps,
    IHasItemDataProps<ISellerExcessDepositViewItem>,
    IHasItemEventProps<ISellerExcessDepositViewItem> {
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent) => void;
}

/*tslint:disable-next-line:variable-name*/
const SellerExcessDeposit = (props: ISellerExcessDepositProps) => (
  <SharedPurchaseItemCells
    sellerAtClosingDisplay="input"
    {...props}
    showRemove={false}
    hasEditPermissions={props.hasEditPermissions}
  >
    Excess Deposit
  </SharedPurchaseItemCells>
);

export default SellerExcessDeposit;
